import { styled, Link } from '@mui/material';

export const InlineLink = styled(Link)(({ theme }) => ({
  color: theme.palette.text.primary,
  textDecoration: 'none',
  fontWeight: 600,
  display: 'inline-flex',
  alignItems: 'center',
}));

/**
 * Detects the user's operating system.
 * Returns one of: 'windows', 'macos', or 'linux'.
 * Defaults to the provided fallback (default is 'linux').
 */
export const detectOS = (): string | undefined => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const platform = ((navigator as any)?.userAgentData?.platform || navigator.platform).toLowerCase();

  if (platform.startsWith('win')) return 'windows';
  if (platform.startsWith('mac')) return 'macos';
  if (platform.includes('linux')) return 'linux';

  return undefined;
};
